import React, { useState } from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import './App.css';
import logo from './assets/mpb_logo.png';
import Home from './components/Home';
import Contact from './components/Contact';
import LearnMore from './components/LearnMore';
import RightOfEntry from './components/RightOfEntry';
import Admin from './components/Admin';
import ImpactMap from './components/Impact/ImpactMap';
import NotFound from './components/NotFound';
import Privacy from './components/Privacy';
import CookieConsent from './components/CookieConsent';
import ScrollToTop from './components/ScrollToTop';
import { DONATE_LINK_PROPS } from './config/donate';

function App() {
  const [navExpanded, setNavExpanded] = useState(false);
  const location = useLocation();

  const handleNavClick = () => {
    setNavExpanded(false);
  };

  return (
    <div className="App min-vh-100 d-flex flex-column">
      <ScrollToTop />
      <Navbar
        variant="dark"
        expand="lg"
        sticky="top"
        className="main-navbar"
        expanded={navExpanded}
        onToggle={setNavExpanded}
      >
        <Container>
          <Navbar.Brand as={Link} to="/" className="d-flex align-items-center" onClick={handleNavClick}>
            <img src={logo} alt="MPB Foundation Logo" width="46" height="46" className="me-2" />
            <span className="fw-bold">MPB Foundation</span>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="main-navbar" />
          <Navbar.Collapse id="main-navbar">
            <Nav className="ms-auto">
              <Nav.Link as={Link} to="/" active={location.pathname === '/'} onClick={handleNavClick}>
                Home
              </Nav.Link>
              <Nav.Link as={Link} to="/learn-more" active={location.pathname === '/learn-more'} onClick={handleNavClick}>
                Learn More
              </Nav.Link>
              <Nav.Link as={Link} to="/impact" active={location.pathname === '/impact'} onClick={handleNavClick}>
                Impact Map
              </Nav.Link>
              <Nav.Link as={Link} to="/right-of-entry" active={location.pathname === '/right-of-entry'} onClick={handleNavClick}>
                Property Evaluation
              </Nav.Link>
              <Nav.Link as={Link} to="/contact" active={location.pathname === '/contact'} onClick={handleNavClick}>
                Contact
              </Nav.Link>
              <Nav.Link
                as="a"
                {...DONATE_LINK_PROPS}
                onClick={handleNavClick}
                className="donate-link"
              >
                Donate
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <main className="flex-grow-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/learn-more" element={<LearnMore />} />
          <Route path="/impact" element={<ImpactMap />} />
          <Route path="/right-of-entry" element={<RightOfEntry />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <footer className="site-footer py-4 mt-auto">
        <Container>
          <div className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-2">
            <div className="d-flex align-items-center gap-2">
              <img src={logo} alt="" width="22" height="22" className="footer-logo" aria-hidden="true" />
              <span className="small">&copy; {new Date().getFullYear()} Mountain Pine Beetle Foundation</span>
            </div>
            <div className="d-flex align-items-center gap-3 small">
              <Link to="/learn-more" className="text-decoration-none">Learn More</Link>
              <a {...DONATE_LINK_PROPS} className="text-decoration-none">Donate</a>
              <Link to="/contact" className="text-decoration-none">Contact</Link>
              <Link to="/privacy" className="text-decoration-none">Privacy</Link>
              <Link to="/admin" className="text-decoration-none">Admin</Link>
            </div>
          </div>
        </Container>
      </footer>

      <CookieConsent />
    </div>
  );
}

export default App;
